import { createSelector } from 'reselect';
import type { FlipperFlagValues } from '../../../../shared/ProductFlipperFlag.service';
import type { FlipperReducer } from '../types/ts/flipperTypes';

function getFeatureName(state: any, featureName: string): string {
  return featureName;
}

export function getFlipperState(state: any): FlipperReducer {
  return state.flipper_updates || {};
}

export const getFlipperFlagValues: (state: any) => FlipperFlagValues = createSelector(
  getFlipperState,
  (flipperState) => flipperState.features || {}
);

// TODO: Rename to isFlipperEnabled (in a new PR not to shadow the diff in the PR)
export const isFeatureEnabled: (state: any, featureName: string) => boolean = createSelector(
  getFlipperFlagValues,
  getFeatureName,
  (features, featureName) => Boolean(features[featureName])
);
